import type { FC } from 'react';
import React, { Fragment } from 'react';

import ModalTransition from '@atlaskit/modal-dialog/modal-transition';

import type { ModalFrame } from './DialogsStateContainer.tsx';

type DialogsComponentProps = {
	stack: ModalFrame[];
};

export const DialogsComponent: FC<DialogsComponentProps> = ({ stack }) => (
	<Fragment>
		{stack.map(({ key, component, alive }) => (
			<ModalTransition key={key}>{alive && component}</ModalTransition>
		))}
	</Fragment>
);
